export const LIST = 1;
export const MAP = 2;